import { render, staticRenderFns } from "./proof-view-file-details.vue?vue&type=template&id=16856ba6&scoped=true&"
import script from "./proof-view-file-details.vue?vue&type=script&lang=js&"
export * from "./proof-view-file-details.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16856ba6",
  null
  
)

export default component.exports